/*
 * Broadcast Theme - Custom JavaScript
 *
 * This file is used for all custom JS added on top of the Broadcast theme.
 * Keeping everything here makes future theme updates easier.
 */

(function () {
  'use strict';

  /* --------------------------------------------------------------------------
   * Helpers
   * ----------------------------------------------------------------------- */

  function isMobileViewport() {
    return window.innerWidth <= 749;
  }

  /* --------------------------------------------------------------------------
   * 1. Testimonials ticker - stop animation on mobile
   * ----------------------------------------------------------------------- */

  var TESTIMONIAL_WRAP_SELECTOR =
    '.testimonials-scrolling-wrap-template--26899883131219__ss_testimonial_16_NjDQXc';

  var TESTIMONIAL_LIST_SELECTOR =
    '.testimonials-scrolling-list-template--26899883131219__ss_testimonial_16_NjDQXc';

  function pauseTestimonialsTicker(wrap, list) {
    if (!wrap || !list) return;

    wrap.classList.add('laqqua-testimonials-paused');

    list.style.animation = 'none';
    list.style.webkitAnimation = 'none';
    list.style.animationPlayState = 'paused';
    list.style.webkitAnimationPlayState = 'paused';

    list.style.transform = 'none';
    list.style.webkitTransform = 'none';
  }

  function attachTestimonialBehavior() {
    var wrap = document.querySelector(TESTIMONIAL_WRAP_SELECTOR);
    var list = document.querySelector(TESTIMONIAL_LIST_SELECTOR);

    if (!wrap || !list) return false;

    if (isMobileViewport()) {
      pauseTestimonialsTicker(wrap, list);
    }

    return true;
  }

  function initTestimonialsWatcher() {
    if (attachTestimonialBehavior()) return;

    var attempts = 0;
    var maxAttempts = 20;

    var timer = setInterval(function () {
      attempts++;

      if (attachTestimonialBehavior() || attempts > maxAttempts) {
        clearInterval(timer);
      }
    }, 500);
  }

  /* --------------------------------------------------------------------------
   * Init
   * ----------------------------------------------------------------------- */

  function initCustomScripts() {

    /* ----------------------------------------------------------------------
     * FORCE NON-TOUCH ON DESKTOP 
     * Broadcast relies on <html class="no-touch"> to render multi-image hovers.
     * If missing, it assumes a touch device → no hover images in DOM.
     * -------------------------------------------------------------------- */
    if (window.matchMedia('(hover: hover)').matches) {
      document.documentElement.classList.add('no-touch');
      document.documentElement.classList.remove('touch');
    }

    // testimonials only — product hover images handled by theme
    initTestimonialsWatcher();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomScripts);
  } else {
    initCustomScripts();
  }
})();

/* ==========================================================================
 * Rete di sicurezza hover-defer (SOLO desktop)
 * Il meccanismo "defer" delle immagini hover è stato rimosso, ma durante la
 * propagazione della cache (o su pagine ancora in cache vecchia) l'HTML può
 * contenere immagini con data-srcset/hover-defer mentre questo JS è già pulito:
 * senza idratazione resterebbero al placeholder = hover rotto. Qui le carichiamo.
 * - Gate (hover:hover): su mobile NON parte → le eventuali differite restano
 *   nascoste (CSS @media hover:none display:none) e non scaricate.
 * - Quando l'HTML è pulito (nessun hover-defer) è un no-op innocuo.
 * ======================================================================== */
(function () {
  'use strict';
  if (!window.matchMedia || !window.matchMedia('(hover: hover)').matches) return;
  function hydrateLeftover() {
    var imgs = document.querySelectorAll('img.hover-defer[data-srcset]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      img.loading = 'eager';
      if (img.dataset.sizes) img.sizes = img.dataset.sizes;
      img.srcset = img.dataset.srcset;
      img.removeAttribute('data-srcset');
      img.classList.remove('hover-defer');
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateLeftover);
  } else {
    hydrateLeftover();
  }
  window.addEventListener('load', function () {
    (window.requestIdleCallback || function (f) { setTimeout(f, 300); })(hydrateLeftover);
  }, { once: true });
})();




/* ==========================================================================
 * Drawer e popup: la chiusura non deve poter restare bloccata
 * (2026-08-17)
 *
 * Bug: a volte il menu laterale, una volta aperto, non si chiude piu' — ne' con
 * la X, ne' toccando lo sfondo, ne' con Esc — e la pagina resta con lo scroll
 * bloccato, quindi serve un reload.
 *
 * Causa: `window.theme.waitForAnimationEnd(el)` (theme.js) e' una Promise che
 * si risolve SOLO sull'evento `animationend` di quell'elemento. Non ha timeout e
 * non ascolta `animationcancel`. Se l'animazione non arriva mai a fine — scheda
 * in background (il timeline delle animazioni si congela), animazione annullata,
 * frame persi su device lenti — la Promise resta appesa, e con lei:
 *   - `header-drawer.isAnimating`, che resta true: showDrawer e hideDrawer
 *     escono subito dalla guardia -> il menu e' inchiodato aperto;
 *   - la classe `is-closing` del cart drawer, che avvelena l'apertura successiva
 *     (e' il bug per cui esiste la rete di sicurezza in sections/cart-drawer.liquid);
 *   - `popupClose()` dei dialog, che chiude solo dentro quella `.then()`.
 *
 * Fix 1: la Promise diventa non-bloccante — si risolve anche su
 * `animationcancel`, subito se l'elemento non esiste, e in ogni caso entro un
 * timeout di sicurezza. Vale per tutti i consumatori: menu, carrello, modali.
 *
 * Fix 2: un tap sulla X / sullo sfondo / su Esc mentre il drawer sta ancora
 * animando viene scartato dal tema (guardia isAnimating) e va perso. Qui la
 * richiesta di chiusura non si perde: si ritenta appena il drawer e' pronto.
 * ======================================================================== */
(function () {
  'use strict';

  if (!window.theme || typeof window.theme.waitForAnimationEnd !== 'function') return;

  /* Piu' lungo dell'animazione piu' lenta che passa da qui (i dialog: fadeIn /
     fadeOut 0.5s), con margine per i device lenti. */
  var FALLBACK_MS = 1200;

  window.theme.waitForAnimationEnd = function (element) {
    return new Promise(function (resolve) {
      if (!element) {
        resolve();
        return;
      }

      var settled = false;
      var timer = null;

      function finish() {
        if (settled) return;
        settled = true;
        element.removeEventListener('animationend', onEnd);
        element.removeEventListener('animationcancel', onEnd);
        if (timer) clearTimeout(timer);
        resolve();
      }

      function onEnd(event) {
        /* Come nell'originale: ignora le animazioni dei figli che risalgono. */
        if (event.target !== element) return;
        finish();
      }

      element.addEventListener('animationend', onEnd);
      element.addEventListener('animationcancel', onEnd);
      timer = setTimeout(finish, FALLBACK_MS);
    });
  };

  /* ---- Fix 2: la richiesta di chiusura del menu non va persa ------------- */

  function requestDrawerClose() {
    var drawer = document.querySelector('header-drawer');
    if (!drawer || !drawer.classList.contains('is-open')) return;

    var attempts = 0;

    (function attempt() {
      /* Il tema ha chiuso: non c'e' altro da fare. */
      if (!drawer.classList.contains('is-open')) return;

      if (!drawer.isAnimating) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:close', {bubbles: true}));
        return;
      }

      if (++attempts > 30) return; /* ~1,5s, poi si lascia perdere */
      setTimeout(attempt, 50);
    })();
  }

  /* Fase bubble su document = si parte DOPO gli handler del tema: se quelli
     hanno funzionato qui non si fa nulla (il drawer non ha piu' is-open). */
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || target.nodeType !== 1 || !target.closest) return;
    if (!target.closest('header-drawer')) return;
    if (target.closest('[data-drawer-close]') || target.hasAttribute('data-drawer-underlay')) {
      requestDrawerClose();
    }
  });

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape' || event.code === 'Escape') requestDrawerClose();
  });
})();

/* ==========================================================================
 * Pagine collezione: il pannello filtri e il bottone «Filtri» si erano persi
 * (2026-08-17)
 *
 * Bug: su ogni pagina collezione parte un `TypeError: Cannot read properties of
 * null (reading 'setAttribute')` da collection.js, e il tasto Esc non chiude il
 * pannello filtri.
 *
 * Causa: `collection-component` cerca il bottone dei filtri dentro di se'
 * (`this.querySelector('[data-aria-toggle]')`), ma nel redesign Laqqua quel
 * bottone e' stato spostato nella riga del titolo, cioe' nella sezione
 * `collection-image-with-title`: fuori dal componente. Quindi `groupTagsButton`
 * resta null e `hideSidebar()` esplode sulla prima riga. L'eccezione interrompe
 * `connectedCallback()` a meta', quindi salta anche la registrazione del
 * listener `theme:filter:close`.
 *
 * Fix: si passa al componente il bottone vero. Cosi' `hideSidebar()` funziona —
 * Esc chiude il pannello e tiene `aria-expanded` allineato alla classe
 * `expanded`, senza sfasare il toggle successivo. La X, «Applica» e lo swipe
 * verso il basso continuano a passare dal codice custom di
 * sections/collection.liquid, che rimane la via principale.
 * ======================================================================== */
(function () {
  'use strict';

  function wireFilterTrigger() {
    var component = document.querySelector('collection-component');
    if (!component || component.groupTagsButton) return;

    var trigger = document.querySelector('.collection-filter-trigger[aria-controls="filter-groups"]');
    if (!trigger) return;

    component.groupTagsButton = trigger;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireFilterTrigger);
  } else {
    wireFilterTrigger();
  }
})();
